<script lang="ts">
  // Компонент подвала сайта
  const currentYear = new Date().getFullYear();
</script>

<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-section">
        <div class="logo">
          <img src="/images/blindeye-logo.svg" alt="BlindEye VPN Logo" class="logo-img" />
          <h2 class="logo-text">BlindEye VPN</h2>
        </div>
        <p class="footer-description">
          Защитите свою конфиденциальность с помощью нашего надежного VPN. BlindEye VPN — Око, которое стало слепым.
        </p>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-heading">Компания</h3>
        <ul class="footer-links">
          <li><a href="#about">О нас</a></li>
          <li><a href="#blog">Блог</a></li>
          <li><a href="#careers">Карьера</a></li>
          <li><a href="#contact">Контакты</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-heading">Продукт</h3>
        <ul class="footer-links">
          <li><a href="#features">Возможности</a></li>
          <li><a href="#pricing">Цены</a></li>
          <li><a href="#download">Скачать</a></li>
          <li><a href="#servers">Серверы</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-heading">Поддержка</h3>
        <ul class="footer-links">
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#tutorials">Инструкции</a></li>
          <li><a href="#support">Поддержка</a></li>
          <li><a href="#status">Статус сервиса</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h3 class="footer-heading">Правовая информация</h3>
        <ul class="footer-links">
          <li><a href="#terms">Условия использования</a></li>
          <li><a href="#privacy">Политика конфиденциальности</a></li>
          <li><a href="#cookies">Политика файлов cookie</a></li>
          <li><a href="#gdpr">GDPR</a></li>
        </ul>
      </div>
    </div>
    
    <div class="footer-bottom">
      <div class="social-links">
        <a href="https://github.com/blindeye-vpn" aria-label="GitHub" class="social-link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.477 2 2 6.477 2 12c0 4.42 2.865 8.166 6.839 9.489.5.092.682-.217.682-.481 0-.237-.008-.865-.013-1.696-2.782.603-3.369-1.342-3.369-1.342-.454-1.155-1.11-1.462-1.11-1.462-.908-.62.069-.608.069-.608 1.003.07 1.531 1.03 1.531 1.03.892 1.529 2.341 1.087 2.91.832.092-.647.35-1.088.636-1.338-2.22-.252-4.555-1.11-4.555-4.943 0-1.091.39-1.984 1.029-2.683-.103-.253-.446-1.27.098-2.647 0 0 .84-.268 2.75 1.026A9.578 9.578 0 0112 6.836c.85.004 1.705.114 2.504.336 1.909-1.294 2.747-1.026 2.747-1.026.547 1.377.202 2.394.1 2.647.64.699 1.028 1.592 1.028 2.683 0 3.842-2.339 4.688-4.566 4.933.359.309.678.919.678 1.852 0 1.336-.012 2.415-.012 2.743 0 .267.18.578.688.48C19.138 20.16 22 16.416 22 12c0-5.523-4.477-10-10-10z"/>
          </svg>
        </a>
        <a href="https://twitter.com/blindeye_vpn" aria-label="Twitter" class="social-link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 01-1.93.07 4.28 4.28 0 004 2.98 8.521 8.521 0 01-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
          </svg>
        </a>
        <a href="https://instagram.com/blindeye_vpn" aria-label="Instagram" class="social-link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 01-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 017.8 2zm-.2 2A3.6 3.6 0 004 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 003.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6zm9.65 1.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM12 7a5 5 0 110 10 5 5 0 010-10zm0 2a3 3 0 100 6 3 3 0 000-6z"/>
          </svg>
        </a>
        <a href="https://wa.me/blindeyevpn" aria-label="WhatsApp" class="social-link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19.05 4.91A9.816 9.816 0 0012 2.5c-5.52 0-10 4.48-10 10 0 1.85.5 3.56 1.37 5.06L2 22l4.5-1.37C7.93 21.5 9.82 22 12 22c5.52 0 10-4.48 10-10 0-2.76-1.12-5.26-2.95-7.09zM12 20c-1.38 0-2.7-.32-3.9-.86l-.28-.16-2.91.87.87-2.87-.18-.29c-.54-1.17-.84-2.44-.84-3.69 0-4.69 3.81-8.5 8.5-8.5 2.28 0 4.37.88 5.95 2.46 1.58 1.58 2.46 3.68 2.46 5.94-.01 4.69-3.82 8.5-8.67 8.5zm4.67-6.36c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.53.07-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.11-.56-1.35-.77-1.84-.2-.48-.4-.42-.56-.43-.14-.01-.31-.01-.48-.01-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.07-.11-.22-.16-.47-.29z"/>
          </svg>
        </a>
        <a href="https://youtube.com/blindeyevpn" aria-label="YouTube" class="social-link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
            <path d="M22.05 7.53c-.16-.65-.77-1.11-1.45-1.25-1.27-.27-6.35-.27-6.35-.27s-5.07 0-6.35.27c-.68.14-1.29.6-1.45 1.25C6.18 8.81 6.18 12 6.18 12s0 3.19.27 4.47c.16.65.77 1.11 1.45 1.25 1.28.27 6.35.27 6.35.27s5.07 0 6.35-.27c.68-.14 1.29-.6 1.45-1.25.27-1.28.27-4.47.27-4.47s0-3.19-.27-4.47zM10.34 14.28V9.72l4.23 2.28-4.23 2.28z"/>
          </svg>
        </a>
      </div>
      
      <div class="copyright">
        &copy; {currentYear} BlindEye VPN. Все права защищены.
      </div>
    </div>
  </div>
</footer>

<style>
  .footer {
    background-color: rgba(0, 0, 0, 0.3);
    padding: 4rem 0 2rem;
    margin-top: 4rem;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: 2fr repeat(4, 1fr);
    gap: 2rem;
    margin-bottom: 3rem;
  }
  
  .logo {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }
  
  .logo-img {
    height: 2.5rem;
    width: auto;
  }
  
  .logo-text {
    font-weight: 900;
    font-size: 1.5rem;
    margin: 0;
    background: linear-gradient(45deg, var(--sauron-red), var(--sauron-yellow));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .footer-description {
    opacity: 0.8;
    line-height: 1.6;
  }
  
  .footer-heading {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    font-weight: 700;
  }
  
  .footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .footer-links li {
    margin-bottom: 0.75rem;
  }
  
  .footer-links a {
    color: inherit;
    text-decoration: none;
    opacity: 0.8;
    transition: opacity 0.3s ease;
  }
  
  .footer-links a:hover {
    opacity: 1;
    color: var(--sauron-red);
  }
  
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 2rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .social-links {
    display: flex;
    gap: 1.5rem;
  }
  
  .social-link {
    color: inherit;
    opacity: 0.7;
    transition: opacity 0.3s ease;
  }
  
  .social-link:hover {
    opacity: 1;
    color: var(--sauron-red);
  }
  
  .social-link svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  
  .copyright {
    opacity: 0.6;
    font-size: 0.875rem;
  }
  
  /* Стили для режима Шира */
  :global(body.shire-mode) .footer {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  :global(body.shire-mode) .footer-links a:hover,
  :global(body.shire-mode) .social-link:hover {
    color: var(--shire-green);
  }
  
  :global(body.shire-mode) .logo-text {
    background: linear-gradient(45deg, var(--shire-green), var(--shire-light));
    -webkit-background-clip: text;
    background-clip: text;
  }
  
  /* Адаптивная версия для мобильных */
  @media (max-width: 1024px) {
    .footer-content {
      grid-template-columns: repeat(3, 1fr);
    }
    
    .footer-section:first-child {
      grid-column: span 3;
      margin-bottom: 2rem;
    }
  }
  
  @media (max-width: 768px) {
    .footer-content {
      grid-template-columns: 1fr 1fr;
    }
    
    .footer-section:first-child {
      grid-column: span 2;
    }
    
    .footer-bottom {
      flex-direction: column;
      gap: 1.5rem;
    }
  }
  
  @media (max-width: 480px) {
    .footer-content {
      grid-template-columns: 1fr;
    }
    
    .footer-section:first-child {
      grid-column: span 1;
    }
  }
</style> 